import axios from 'axios'
import _ from 'lodash'
var audio = new Audio('/snd/notif.mp3')

export default {
  namespaced: true,
  state: {
    allTotal: [],
    cashInfo: null,
    usersInfo: null,
    manualCashInfo: null,
    betInfo: null,
    pointsInfo: null,

    notif: {
      cashin: false,
      cashout: false,
      cashwait: false,
      newuser: false,
      help: false,
      waituser: false
    }
  },
  getters: {
  },
  mutations: {
    SET_META (state, data) {
      state.allTotal = data
    },

    SET_CASHINFO (state, data) {
      data.net = parseInt(data.total_cash_in - data.total_cash_out)
      state.cashInfo = data
    },

    SET_USERSINFO (state, data) {
      state.usersInfo = data
    },

    SET_MANUALCASHINFO (state, data) {
      data.net = parseInt(data.total_cash_in - data.total_cash_out)
      state.manualCashInfo = data
    },

    SET_BETINFO (state, data) {
      data.net = parseInt(data.total_bet_amount - data.total_win_amount)
      state.betInfo = data
    },

    SET_POINTS (state, data) {
      // data.net = parseInt(data.total_bet_amount - data.total_win_amount)
      state.pointsInfo = data
    }
  },

  actions: {
    async get ({ commit }) {
      try {
        let response = await axios.get('/meta/all')
        commit('SET_META', response.data)
      } catch (err) {

      }
    },

    async  getCashInfo ({ commit }) {
      try {
        let response = await axios.get('/meta/cash')
        commit('SET_CASHINFO', response.data)
      } catch (err) {
        console.log(err)
      }
    },

    async  getManualInfo ({ commit }) {
      try {
        let response = await axios.get('/meta/manual')
        commit('SET_MANUALCASHINFO', response.data)
      } catch (err) {
        console.log(err)
      }
    },

    async  getUsersInfo ({ commit }) {
      try {
        let response = await axios.get('/meta/users')
        commit('SET_USERSINFO', response.data)
      } catch (err) {
        console.log(err)
      }
    },

    async getBetInfo ({ commit }) {
      try {
        let response = await axios.get('/meta/bets')
        commit('SET_BETINFO', response.data)
      } catch (err) {
        console.log(err)
      }
    },

    async getPointsInfo ({ commit }) {
      try {
        let response = await axios.get('/meta/points')
        commit('SET_POINTS', response.data)
      } catch (err) {
        console.log(err)
      }
    },

    setMeta ({ commit, state }, event) {
      if (event === 'cashin') {
        state.allTotal.total_cash_in += 1
      }
      if (event === 'cashout') {
        state.allTotal.total_cash_out += 1
      }
      if (event === 'new-user') {
        state.allTotal.total_pending_users += 1
      }
      if (event === 'new-request') {
        state.allTotal.total_pending_help += 1
      }
    },

    setUserInfo ({ commit, state }, event) {
      if (event === 'login') {
        // state.usersInfo.total_online += 1
      }
      if (event === 'logout') {
        // state.usersInfo.total_online -= 1
      }

      if (event === 'new-user') {
        state.usersInfo.total_pending_users += 1
      }
    },

    setBetInfo ({ commit, state }, { event, data }) {
      if (event === 'new-bet') {
        data.forEach((item) => {
          state.betInfo.total_bet_amount += item.bet_amount
        })

        state.betInfo.net = parseInt(state.betInfo.total_bet_amount - state.betInfo.total_win_amount)
      }
    },

    setNotif ({ commit, state }, data) {
      data.forEach((e) => {
        console.log(e, 'reciv for notifs')
        state.notif[e.key] = e.value
      })
      audio.play()
    }
  }
}
